webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  count: 1,
  phrases: {
    current: null,
    boards: {},
    sets: {
      selected: { key: 'hgc-eu-2017-phase2', text: 'HGC Europe 2017 Phase 2' },
      available: [{ key: 'hgc-eu-2017-phase2', text: 'HGC Europe 2017 Phase 2' }, { key: 'heroes-bingo-2015', text: 'Heroes Bingo 2015' }]
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(17),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_stash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(1);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_stash___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },
  data: { store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */] }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Controls__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Controls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Controls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BoardsList__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BoardsList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_BoardsList__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Controls: __WEBPACK_IMPORTED_MODULE_0__components_Controls___default.a,
    BoardsList: __WEBPACK_IMPORTED_MODULE_1__components_BoardsList___default.a
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'boards-list',
  store: {
    count: 'count',
    phrases: 'phrases'
  },
  methods: {
    shuffle: function shuffle(arr) {
      var shuffled = arr.slice();
      var currentIndex = arr.length;
      var temporaryValue = void 0;
      var randomIndex = void 0;

      while (currentIndex !== 0) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        temporaryValue = shuffled[currentIndex];
        shuffled[currentIndex] = shuffled[randomIndex];
        shuffled[randomIndex] = temporaryValue;
      }

      return shuffled;
    },
    getBoard: function getBoard(n) {
      while (this.phrases.current == null) {}

      if (!this.phrases.boards[n]) {
        this.phrases.boards[n] = this.shuffle(this.phrases.current).slice(0, 25);
      }

      return this.phrases.boards[n];
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'controls',
  store: {
    count: 'count',
    phrases: 'phrases'
  },
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a,
    VueSlider: __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },
  methods: {
    updatePhrases: function updatePhrases() {
      var _this = this;

      fetch('./static/phrases/' + this.phrases.sets.selected.key + '.json').then(function (r) {
        return r.json();
      }).then(function (json) {
        _this.phrases.current = json;
        _this.phrases.boards = {};
      });
    },
    shuffle: function shuffle() {
      this.phrases.boards = {};
    },
    print: function print() {
      window.print();
    }
  },
  created: function created() {
    this.updatePhrases();
  }
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.82963a4.png";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(18),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e53d423c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(16),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3172b74d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "controls"
    }
  }, [_c('div', [_c('h1', [_vm._v("Heroes of the Storm Bingo Generator")]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("Number of boards")]), _vm._v(" "), _c('dd', {
    staticClass: "boards-count"
  }, [_c('vue-slider', {
    attrs: {
      "min": 1,
      "max": 10,
      "tooltip": "hover"
    },
    model: {
      value: (_vm.count),
      callback: function($$v) {
        _vm.count = $$v
      },
      expression: "count"
    }
  })], 1), _vm._v(" "), _c('dt', [_vm._v("Phrase set")]), _vm._v(" "), _c('dd', {
    staticClass: "phrase-set"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.phrases.sets.available,
      "show-labels": false,
      "allow-empty": false,
      "label": "text",
      "track-by": "key"
    },
    on: {
      "input": _vm.updatePhrases
    },
    model: {
      value: (_vm.phrases.sets.selected),
      callback: function($$v) {
        _vm.phrases.sets.selected = $$v
      },
      expression: "phrases.sets.selected"
    }
  })], 1)]), _vm._v(" "), _c('h3', [_vm._v("How to use")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.shuffle
    }
  }, [_c('span', [_vm._v("Shuffle")])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.print
    }
  }, [_c('span', [_vm._v("Print")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Choose your desired phrase set.")]), _vm._v(" "), _c('li', [_vm._v("Adjust number of boards to match players.")]), _vm._v(" "), _c('li', [_vm._v("Print this page. It will automatically be converted to the printer friendly version.")])])
}]}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('controls'), _vm._v(" "), _c('boards-list')], 1)
},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.phrases.current != null) ? _c('div', {
    attrs: {
      "id": "boards-list"
    }
  }, _vm._l((parseInt(_vm.count)), function(n) {
    return _c('div', {
      key: n,
      staticClass: "bingo-board-container"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "bingo-board"
    }, _vm._l((5), function(row) {
      return _c('ul', {
        key: row,
        staticClass: "bingo-row"
      }, _vm._l((5), function(col) {
        return _c('li', {
          key: col
        }, [_c('div', {
          staticClass: "hexagon-container"
        }, [_c('div', {
          staticClass: "hexagon-text"
        }, [_c('span', [_vm._v(_vm._s(_vm.getBoard(n)[(row - 1) * 5 + (col - 1)]))])]), _vm._v(" "), _c('div', {
          staticClass: "hexagon"
        })])])
      }))
    })), _vm._v(" "), _vm._m(1, true), _vm._v(" "), (n != _vm.count) ? _c('div', {
      staticClass: "page-break"
    }) : _vm._e()])
  })) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": "Heroes of the Storm"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "instructions"
  }, [_vm._v("\n      While you watch the "), _c('em', [_vm._v("Heroes of the Storm")]), _vm._v(", mark each hex as a caster says the indicated phrase. Be the first player to mark five hexes in a row (horizontal, vertical, or diagonal) and shout “"), _c('strong', [_vm._v("BINGO")]), _vm._v("” to win!\n    ")])
}]}

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.753eadfdf53205e682b0.js